import { resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { useSlots, computed, watch, ref } from 'vue'; // eslint-disable-line

export default {
  __name: 's-model-value-adapter',
  props: {
    modelValue: {},
    type: String
  },
  emits: 'update:modelValue',
  setup(__props, {
    emit: __emit
  }) {
    const slots = useSlots();
    const props = __props;
    const emits = __emit; // eslint-disable-line

    const formattedValue = (value, toExternal) => {
      if (props.type === 'date') {
        if (!value) return;
        const date = new Date(value);
        if (!isNaN(date)) {
          return toExternal ? date.toISOString() : date.toISOString().split('T')[0];
        }
        return value;
      }
      return value;
    };
    const internalValue = ref(formattedValue(props.modelValue));

    /** 2️⃣ Sincronizar prop externo → interno */
    // watch(() => props.modelValue, v => {
    //   internalValue.value = toInternal(v)
    // }, { immediate: true })

    const proxyValue = computed({
      get() {
        return internalValue.value;
      },
      set(newInternal) {
        internalValue.value = newInternal;
        const iso = formattedValue(newInternal, true);
        emits('update:modelValue', iso);
      }
    });
    const childVNode = computed(() => {
      const vnodes = slots.default?.() || [];
      if (vnodes.length !== 1) {
        return null;
      }
      return vnodes[0];
    });
    return (_ctx, _cache) => {
      return childVNode.value ? (_openBlock(), _createBlock(_resolveDynamicComponent(childVNode.value.type), _mergeProps({
        key: 0
      }, childVNode.value.props, {
        modelValue: proxyValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => proxyValue.value = $event)
      }), null, 16, ["modelValue"])) : _createCommentVNode("", true);
    };
  }
};